var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('page-header',{attrs:{"header":_vm.$t('import_entities.title')}}),_c('div',{staticClass:"content"},[_c('b-card',[_c('resource-form',{on:{"saved":_vm.returnBack,"cancelled":_vm.returnBack}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }